import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { BookingConfirmAppointmentActions, selectExternalNote } from '@modules/booking/store/appointment';

import { BaseForm } from '@modules/core/abstract-classes';
import { FormGroup } from '@angular/forms';
import { ModelFormGroup } from '@modules/core/types';
import { ExternalNoteForm } from '@modules/core/interfaces';

@Component({
  selector: 'pub-appointment-external-note',
  templateUrl: './appointment-external-note.component.html',
  styleUrls: ['./appointment-external-note.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppointmentExternalNoteComponent extends BaseForm implements OnInit, OnDestroy {
  form!: FormGroup<ModelFormGroup<ExternalNoteForm>>;
  externalNote$ = this.store.select(selectExternalNote);
  destroy$ = new Subject();

  @ViewChild('externalNoteField', { static: false }) externalNoteField!: ElementRef;
  public showExternalNoteField = false;

  constructor(private store: Store, private router: Router, private cdRef: ChangeDetectorRef) {
    super('initExternalNoteForm');
  }

  ngOnInit() {
    const allowedPathsForExternalNote = ['confirm/register', 'confirm/guest', 'confirm/authorized'];

    this.router.events.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.showExternalNoteField = allowedPathsForExternalNote.some((path) => this.router.url.includes(path));
      this.cdRef.detectChanges();
    });

    this.form.controls['externalNote'].valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.store.dispatch(BookingConfirmAppointmentActions.setExternalNote({ externalNote: value }));
    });
  }


  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
